export default __webpack_public_path__ + "svg/calendar/2025/1/abril.svg?df3141c1";